<template>
  <div class="upData">
    <v-head></v-head>
    <div class="contentBox">
      <div class="detailsBox" v-if="info">
        <div class="detailsTit">
          <p class="left"><span>产品名称</span>{{ info.plan.productName }}</p>
          <p class="right">
            <span>应付总额： </span>{{ info.policyMoney }} 元
            <span class="cutShow" @click="cutShow">
              详情<i class="el-icon-arrow-down"></i>
            </span>
          </p>
        </div>
        <div class="detailsCon" v-show="show">
          <p>保险公司：{{ info.companyName }}</p>
          <p>职业类别：{{ info.workCate }}</p>
          <p>{{ info.plan.death_quota }}</p>
          <p>{{ info.plan.loss_work_cost }}</p>
          <p>{{ info.plan.medical_quota }}</p>
          <p>{{ info.plan.hospital_allowance }}</p>
          <p>{{ info.plan.legal_fees }}</p>
          <p>流水号：{{ info.numId }}</p>
          <p>渠道标识：{{ info.adminName }}</p>
          <p>保障期限：{{ info.sTime }} - {{ info.eTime }}</p>
        </div>
      </div>
      <div class="stepBox">
        <p>
          <img src="@/assets/images/product/stepbg1.png" alt="" />
          <span><i class="el-icon-success"></i> 1、填写投保信息 </span>
        </p>
        <p class="activate">
          <img src="@/assets/images/product/stepbg2_a.png" alt="" />
          <span> 2、上传投保资料 </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg2.png" alt="" />
          <span> 3、支付保费 </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg3.png" alt="" />
          <span> 4、完成 </span>
        </p>
      </div>
      <div class="uploadStepBox" v-if="!certification && !isSigntory">
        <div class="item">
          <div class="upSTit">
            <img src="@/assets/images/product/ziliaoxz.png" alt="" />
            <p>
              已生成投保资料
              <span>
                <i class="el-icon-warning-outline"></i>
                下载此投保资料，加盖公章后，再上传！
              </span>
            </p>
          </div>
          <div class="upSCon">
            <p>
              <a :href="info.insureFile">
                <i class="el-icon-download"></i> 投保资料
              </a>
            </p>
          </div>
        </div>
        <div class="item">
          <div class="upSTit">
            <img src="@/assets/images/product/ziliaoshagnc.png" alt="" />
            <p>上传投保资料</p>
          </div>
          <div class="upSCon">
            <el-upload
              drag
              action="/api/upload/upload"
              name="file"
              multiple
              :http-request="upload"
              :file-list="insureFile"
              :on-remove="removeFile"
            >
              <img src="@/assets/images/product/upload.png" alt="" />
              <div>
                <div class="el-upload__text">
                  将投保资料拖到此处，或<em>点击上传</em>
                </div>
                <p>文件上传不得超过100M，支持pdf、word格式！</p>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="iframeBox" v-else>
        <iframe :src="baseUrl + iframeSrc" frameborder="0"></iframe>
      </div>
      <el-button type="primary" class="goPay" @click="goPay">
        提交审核
      </el-button>
    </div>
    <v-foot
      :id="info.agent_id"
      :tit="info.agent_name"
      type="1"
      v-if="info"
    ></v-foot>
    <!-- 电子签章确认是否签署 -->
    <el-dialog
      top="calc(100vh - 700px)"
      title="合同签署状态"
      :visible.sync="isSigntory"
      :show-close="false"
      width="420px"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="signtory"
    >
      <div class="signtorybox">
        <img src="@/assets/images/product/contractimg.png" alt="" />
        <el-form
          ref="form"
          :model="signtoryForm"
          :rules="signtoryRules"
          size="mini"
          label-width="140px"
          style="margin-right:50px;"
        >
          <el-form-item label="签署人：" prop="name">
            <el-input v-model.trim="signtoryForm.name" :disabled="disabledName">
              <i
                slot="suffix"
                class="el-icon-edit"
                @click="disabledName = false"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="签署人电话：" prop="phone">
            <el-input
              v-model.trim="signtoryForm.phone"
              :disabled="disabledPhone"
            >
              <i
                slot="suffix"
                class="el-icon-edit"
                @click="disabledPhone = false"
              ></i
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="small" @click="getContractFile">
          我已完成签署
        </el-button>
        <el-button size="small" @click="getContractFileUrl">
          去签署
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import vHead from "@/components/vhead";
import vFoot from "@/components/vFoot";
import { upload } from "@/api/public";
import { uploadInsureFile } from "@/api/insure";
import { getOrderInfo } from "@/api/guarantee";
import {
  getIsContract,
  getContractFileUrl,
  getContractFile,
  getOrderContractInfo
} from "@/api/signature";
export default {
  name: "upData",
  components: {
    vHead,
    vFoot
  },
  data() {
    return {
      show: false,
      numId: "",
      insureFile: [],
      info: "",
      NoFollow: false, //是否需要电子签章
      certification: false, //是否已经认证
      isSigntory: false, //确认是否签署弹窗
      signtoryForm: {
        name: "", //电子签章联系人
        phone: "" //电子签章联系人电话
      },
      signtoryRules: {
        name: [{ required: true, message: "签署人不能为空", trigger: "blur" }],
        phone: [
          { required: true, message: "签署人电话不能为空", trigger: "blur" },
          {
            pattern: /^1[0-9]{10}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ]
      },
      disabledName: true, //电子签章联系人是否可以修改
      disabledPhone: true, //电子签章联系人电话是否可以修改
      iframeSrc: "", //电子签章合同地址
      contractId: "", //电子签章合同id
      baseUrl: this.$store.state.baseUrl //域名
    };
  },
  mounted() {
    this.numId = this.$route.query.numId;
    this.getOrderInfo();
  },
  methods: {
    //获取订单详情
    getOrderInfo() {
      let that = this;
      getOrderInfo({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.info = res.data;
            that.getIsContract(); //获取电子签章信息
            // 设置title
            document.title = "上传资料--" + res.data.applicationName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 详情显示隐藏
    cutShow() {
      if (this.show) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    //上传文件
    upload(e) {
      console.log(e);
      let that = this;
      let form = new FormData();
      form.append("file", e.file);
      form.append("folder", "other");
      upload(form)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            let _data = { name: res.data.fileName, url: res.data.fileUrl };
            that.insureFile.push(_data);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 移除
    removeFile(e, list) {
      console.log(e, list);
      let _array = [];
      list.forEach(element => {
        let _data = {
          name: element.name,
          url: element.url
        };
        _array.push(_data);
      });
      this.insureFile = _array;
    },
    // 提交
    goPay() {
      let that = this;
      let _data = {
        numId: that.numId,
        insureFile: []
      };
      that.insureFile.forEach(element => {
        _data.insureFile.push(element.url);
      });
      console.log(_data);
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      uploadInsureFile(_data)
        .then(function(res) {
          console.log(res);
          loadind.close();
          if (res.code == 1) {
            that.$message.success(res.msg);
            if (res.data.nextStep == 1) {
              that.$router.push({
                path: "/insure/pay",
                query: { numId: that.numId }
              });
            } else {
              that.$router.push({
                path: "/guarantee"
              });
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 判断是否需要电子签章，是否已经认证
    getIsContract() {
      let that = this;
      let _data = {
        proNum: this.info.productCode,
        numId: this.numId,
        uid: this.$store.getters.id
      };
      getIsContract(_data)
        .then(function(res) {
          console.log(res);
          if (res.code == 200) {
            if (res.data.isContract == 1) {
              that.NoFollow = true;
            } else {
              that.NoFollow = false;
            }
            if (res.data.isCertified == 1) {
              that.certification = true;
            } else {
              that.certification = false;
            }
            that.signtoryForm = {
              name: res.data.signer, //电子签章联系人
              phone: res.data.signerContact //电子签章联系人电话
            };
            if (that.NoFollow && that.certification) {
              that.getOrderContractInfo(); //调取合同信息
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 获取电子合同信息
    getOrderContractInfo() {
      let that = this;
      getOrderContractInfo({ numId: that.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 200) {
            that.iframeSrc = res.data.contractFile;
            that.contractId = res.data.contractId;
            if (that.iframeSrc == null) {
              that.isSigntory = true;
            } else {
              that.isSigntory = false;
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 去签署电子签章
    getContractFileUrl() {
      let that = this;
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getContractFileUrl({
        uid: that.$store.getters.id,
        numId: that.numId,
        vcodeMobile: that.signtoryForm.phone
      })
        .then(function(res) {
          console.log(res);
          loadind.close();
          if (res.code == 200) {
            that.contractId = res.data.contractId;
            if (!res.data.contractFile) {
              let tempwindow = window.open("_blank"); // 先打开页面
              tempwindow.location = res.data.url; // 后更改页面地址
            } else {
              that.$message.success("已完成签署完成");
              that.iframeSrc = res.data.contractFile;
              let _url = {
                url: that.iframeSrc
              };
              that.insureFile.push(_url);
              that.isSigntory = false;
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 锁定合同
    getContractFile() {
      let that = this;
      if (!that.contractId) {
        that.$message.error("请先点击“去签署”按钮签署合同");
        return;
      }
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getContractFile({
        uid: that.$store.getters.id,
        contractId: that.contractId
      })
        .then(function(res) {
          console.log(res);
          loadind.close();
          if (res.code == 200) {
            that.$message.success(res.msg);
            that.iframeSrc = res.data.fileUrl;
            that.isSigntory = false;
            let _url = {
              url: that.iframeSrc
            };
            that.insureFile.push(_url);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.upData {
  width: 100%;
  background: #eff2f4;
  padding-top: 54px;
  background-image: url("~@/assets/images/product/main-bg.png");
  background-size: cover;
  & > .contentBox {
    width: 100%;
    max-width: 1200px;
    margin: 35px auto;
    background: #ffffff;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.07);
    border-radius: 10px;
    overflow: hidden;
    .detailsBox {
      padding: 0 24px;
      .detailsTit {
        border-bottom: 1px dotted #9797974d;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0 10px;
        & > .left {
          font-size: 22px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
          margin: 0;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            background-image: linear-gradient(to right, #ff9a5d, #f66735);
            border-radius: 15px 0px 15px 0px;
            display: inline-block;
            padding: 0 20px;
            margin-right: 5px;
            line-height: 24px;
            margin-right: 15px;
            display: inline-block;
          }
        }
        & > .right {
          font-size: 24px;
          font-weight: 600;
          color: #f76a37;
          margin: 0;
          span {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
          }
          .cutShow {
            padding: 15px 0 15px 15px;
            display: inline-block;
            cursor: pointer;
          }
        }
      }
      .detailsCon {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 30px;
        padding: 15px;
        p {
          margin: 0;
        }
      }
    }
    .stepBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 25px 0 40px;
      p {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        width: 220px;
        height: 36px;
        margin: 0;
        img {
          width: 100%;
          height: 100%;
        }
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          text-align: center;
          i {
            font-size: 20px;
            color: #55d091;
            vertical-align: middle;
          }
        }
      }
      p + p {
        margin-left: -10px;
      }
      p.activate {
        color: rgba(255, 255, 255, 0.85);
      }
    }
    .uploadStepBox {
      padding-left: 120px;
      padding-right: 100px;
      & > .item {
        .upSTit {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          & > img {
            width: 40px;
            height: 40px;
            margin-right: 20px;
          }
          p {
            font-size: 20px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 28px;
            margin: 0;
            span {
              background: #fdf2d4;
              border-radius: 3px;
              display: inline-block;
              font-size: 14px;
              font-weight: 400;
              color: #f86c07;
              line-height: 20px;
              margin-left: 15px;
              padding: 6px 15px 6px 20px;
              i {
                font-size: 16px;
                color: #ee4039;
              }
            }
          }
        }
        .upSCon {
          position: relative;
          margin-top: 15px;
          margin-bottom: 45px;
          margin-left: 60px;
          & > p {
            margin: 0;
            padding: 10px 25px 13px;
            border-radius: 3px;
            border: 1px solid #dedede;
            & > a {
              display: block;
              font-size: 16px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              line-height: 25px;
              i {
                color: #2d8aee;
              }
            }
          }
          .el-upload {
            width: 100%;
            .el-upload-dragger {
              border-radius: 3px;
              border: 1px solid #dedede;
              width: 100%;
              height: 180px;
              background: #fcfcfc;
              display: flex;
              justify-content: center;
              align-items: center;
              img + div {
                margin: 0 50px;
                .el-upload__text {
                  font-size: 16px;
                  font-weight: 400;
                  color: #000000;
                  line-height: 22px;
                }
                p {
                  font-size: 12px;
                  margin: 5px 0 0;
                  font-weight: 400;
                  color: #f86c07;
                  line-height: 17px;
                }
              }
            }
          }
        }
        .upSCon::before {
          content: "";
          display: block;
          width: 1px;
          height: 110px;
          position: absolute;
          top: -16px;
          left: -40px;
          background: #8ea6bf82;
        }
      }
      & > .item + .item {
        .upSCon::before {
          display: none;
        }
      }
    }
    // 电子合同
    .iframeBox {
      min-height: 500px;
      margin-bottom: 25px;
      iframe {
        width: 100%;
        height: calc(100vh - 250px);
      }
    }
    .el-button.goPay {
      margin: 0 auto 35px;
      display: block;
    }
  }
}

.el-dialog__wrapper.signtory {
  .el-dialog__body {
    text-align: center;
    .signtorybox {
      .el-form-item__content {
        .el-input__suffix {
          cursor: pointer;
          font-size: 16px;
          color: #409eff;
        }
      }
      .el-button {
        margin: 25px 0 10px;
        width: 115px;
      }
      .el-button + .el-button {
        margin-left: 10px;
      }
    }
  }
}
</style>
